export var IntelligentPhotoCaptureImgAnalyzerScoreStatus;
(function (IntelligentPhotoCaptureImgAnalyzerScoreStatus) {
    IntelligentPhotoCaptureImgAnalyzerScoreStatus["LOADING"] = "loading";
    IntelligentPhotoCaptureImgAnalyzerScoreStatus["SUCCESS"] = "success";
    IntelligentPhotoCaptureImgAnalyzerScoreStatus["FAIL"] = "fail";
})(IntelligentPhotoCaptureImgAnalyzerScoreStatus || (IntelligentPhotoCaptureImgAnalyzerScoreStatus = {}));
//# sourceMappingURL=IntelligentPhotoCaptureImgAnalyzerScoreStatus.js.map